import SectionHeader from "../components/SectionHeader";
import Seo from "../components/Seo";
import { resumeUrl } from "../content";
import { breadcrumbSchema } from "../lib/structuredData";

function ResumePage() {
  return (
    <section id="resume">
      <Seo
        description="Download Robert Doe's CV covering research, teaching, publications, and full-stack and security engineering experience."
        jsonLd={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Resume", path: "/resume" }])}
        path="/resume"
        title="Resume - Robert Doe"
      />
      <SectionHeader number="06" title="Resume" />
      <div className="resume-card reveal">
        <div className="resume-info">
          <div className="resume-title">Curriculum Vitae</div>
          <p className="resume-note">
            A single document covering research, teaching, publications, and
            engineering experience.
          </p>
        </div>
        <a className="btn-primary resume-download" download href={resumeUrl}>
          Download CV (PDF)
        </a>
      </div>
    </section>
  );
}

export default ResumePage;
